export interface ISecret {
  idCognito: string;
  key: string;
  value: string;
}

export enum SecretKey {
  ROUNDPOINT_MORTGAGE_PASSWORD = 'ROUNDPOINT_MORTGAGE_PASSWORD',
}
